import * as React from 'react';

import classnames from 'classnames';

import {Body} from '../typography/body';

import {createCta} from './helpers';

import styles from './promo-state.module.css';

export type CTA = {
    text: string;
    onClick?: () => void;
    url?: string;
    isExternalLink?: boolean;
};

export type PromoStateProps = {
    isHorizontal: boolean;
    imageUrl?: string;
    imageComponent?: React.ReactNode;
    title: string;
    subtitle: string;
    alignBottom?: boolean;
    primaryCta: CTA | null | undefined;
    secondaryCta: CTA;
    maxHeight?: string;
    blueImageBackground?: boolean;
};

export function PromoState(props: PromoStateProps) {
    const primaryCta = props.primaryCta ? createCta(props.primaryCta, true) : null;
    const secondaryCta = createCta(props.secondaryCta, false);

    const containerStyle = classnames({
        [styles['container--horizontal-bottom']]: props.isHorizontal && props.alignBottom,
        [styles['container--horizontal']]: props.isHorizontal && !props.alignBottom,
        [styles['container--vertical']]: !props.isHorizontal,
    });

    const footerStyle = classnames(styles.footer, {
        [styles['footer--horizontal']]: props.isHorizontal,
    });

    const imageContainerStyle = classnames(styles['image-container'], {
        [styles['image-container--blue-background']]: props.blueImageBackground,
    });

    return (
        <div
            // @ts-expect-error
            style={{maxHeight: props.maxHeight ? props.maxHeight : null}}
            className={containerStyle}
        >
            {props.imageUrl && (
                <div className={imageContainerStyle}>
                    <img src={props.imageUrl} alt='Promo card thumbnail' className={styles.image} />
                </div>
            )}
            {props.imageComponent && !props.imageUrl && (
                <div className={imageContainerStyle}>{props.imageComponent}</div>
            )}
            <div className={styles['text-container']}>
                <Body isBold={true} size='normal'>
                    {props.title}
                </Body>
                <Body size='normal'>{props.subtitle}</Body>
                <div className={footerStyle}>
                    <div>{primaryCta}</div>
                    <div>{secondaryCta}</div>
                </div>
            </div>
        </div>
    );
}
